module.exports = __webpack_public_path__ + "57694f2467ce569309e0e57a0f9bc2c9.pdf";